module.exports = __webpack_public_path__ + "img/aa5fb46.svg";